import {
  ADDORUPDATEBUSINESSNATURE_SUCCESS,
  ADDORUPDATEBUSINESSNATURE_FAILED,
  RESET_ADDORUPDATEBUSINESSNATURE,
  LOADING_ADDORUPDATEBUSINESSNATURE,
  NETWORK_ERROR_ADDORUPDATEBUSINESSNATURE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADDORUPDATEBUSINESSNATURE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case ADDORUPDATEBUSINESSNATURE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case ADDORUPDATEBUSINESSNATURE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_ADDORUPDATEBUSINESSNATURE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_ADDORUPDATEBUSINESSNATURE:
      return (state = initialState);
    default:
      return state;
  }
};
